module.exports = __webpack_public_path__ + "static/media/DSC01505.ed959e2d.jpg";